import { render, staticRenderFns } from "./EditSectionPoint.vue?vue&type=template&id=1643aefa"
import script from "./EditSectionPoint.vue?vue&type=script&lang=js"
export * from "./EditSectionPoint.vue?vue&type=script&lang=js"
import style0 from "./EditSectionPoint.vue?vue&type=style&index=0&id=1643aefa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports